<template>
	<div class="memberLog layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				注册资料
			</div>
		</div>
		<div class="layui-form px16" action="">
			<table class="layui-table bge" style="width:48%;margin: 50px 0 50px 26%;">
				<colgroup>
					<col width="20%">
					<col width="20%">
					<col width="20%">
					<col width="20%">
				</colgroup>
				<tbody class="align_center px16">
					<tr>
						<td class="ft_wt">公司名称</td>
						<td>{{infos.corporate_name}}</td>
						<td class="ft_wt">注册资本</td>
						<td colspan="2">{{infos.registered_capital}}</td>
					</tr>
					<tr>
						<td class="ft_wt">法定代表人</td>
						<td>{{infos.legal_representative}}</td>
						<td class="ft_wt">民族</td>
						<td colspan="2">{{infos.nation}}族</td>
					</tr>
					<tr>
						<td class="ft_wt">联系电话</td>
						<td>{{infos.phone}}</td>
						<td class="ft_wt">从业年限</td>
						<td colspan="2">{{infos.working_life}}</td>
					</tr>
					<tr>
						<td class="ft_wt">合作意向</td>
						<td>{{infos.cooperation == 1 ? '全职' : '兼职'}}</td>
						<td class="ft_wt">QQ</td>
						<td colspan="2">{{infos.qq}}</td>
					</tr>
					<tr>
						<td class="ft_wt">银行卡号</td>
						<td colspan="4">{{infos.bank_account}}</td>
					</tr>
					<tr>
						<td class="ft_wt">注册地址</td>
						<td colspan="4">{{infos.registration_address}}</td>
					</tr>
					<tr>
						<td class="ft_wt">工作邮箱</td>
						<td>{{infos.email}}</td>
						<td class="ft_wt">员工人数</td>
						<td colspan="2">{{infos.staff_num}}</td>
					</tr>
					<tr>
						<td class="ft_wt" colspan="4">激光切割机明细</td>
					</tr>
					<tr>
						<td class="ft_wt">设备</td>
						<td class="ft_wt">型号</td>
						<td class="ft_wt">设备每月产能</td>
						<td class="ft_wt">每月意向接单数量</td>
					</tr>
					<tr v-for="(item,i) in infos.laser_cutting_machine" :key="i">
						<td>{{item.equipment}}</td>
						<td>{{item.model}}</td>
						<td>{{item.capacity}}</td>
						<td>{{item.num}}</td>
					</tr>
					<tr style="border-bottom: 1px solid #000;">
						<td class="ft_wt">地址</td>
						<td colspan="4" style="position: relative;">
							<div id="baiduMap" style="height: 400px;"></div>
							<div style="position: absolute;top: 10px;left: 10px;z-index: 888;">
								<div id="searchResultPanel" style="display: none;"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="hint">您的信息如需变更，请及时联系我们平台工作人员进行修改，谢谢。</div>
		</div>
	</div>
</template>

<script>
	var map = '';
	export default {
		name: 'memberLog',
		data() {
			return {
				infos: {}
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['layer', 'table'], function() {
				var table = layui.table;
				api.getMemberInfo({ //获取会员信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						res.data.laser_cutting_machine = JSON.parse(res.data.laser_cutting_machine);
						_this.infos = res.data;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
					_this.createMap(res.data.lng,res.data.lat);
				});
			});
		},
		methods: {
			createMap(lng,lat) {
				let _this = this;
				map = new BMap.Map("baiduMap", {
					enableMapClick: false
				});
				map.centerAndZoom(new BMap.Point(lng, lat), 17); // 创建点坐标,初始化地图,设置中心点坐标和地图级别
				map.enableScrollWheelZoom(false); //开启鼠标滚轮缩放
				map.addOverlay(new BMap.Marker(new BMap.Point(lng, lat))); //添加标注
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.memberLog {
		font-family: SourceHanSansSC;
	}
	
	.bge td {
		line-height: 45px;
		min-height: 45px;
		height: 45px;
		padding: 0;
		border-width: 1px;
		border-color: #000;
		position: inherit;
	}
	
	.bge input {
		width: 100%;
		text-align: center;
		display: block;
		height: 45px;
		border: none;
	}
	
	.hint {
		text-align: center;
		color: #FF0000;
		margin: 50px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/memberLog.vue